import * as tslib_1 from "tslib";
import { CollectionSwitch } from './collection_switch';
var RadioGroup = /** @class */ (function (_super) {
    tslib_1.__extends(RadioGroup, _super);
    function RadioGroup(param) {
        return _super.call(this, param) || this;
    }
    RadioGroup.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "RadioGroup" });
    };
    RadioGroup.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return RadioGroup;
}(CollectionSwitch));
export { RadioGroup };
//# sourceMappingURL=radio_group.js.map